<template>
    <div ref="playerWrapper"
         class="pip-player-control-wrapper">
        <PlayerControls />
    </div>
</template>

<script setup>
    import { inject, ref, onMounted } from "vue";

    import PlayerControls from "@/components/Streaming/PlayerControls.vue";

    import { usePipController } from "@/components/Streaming/controllers/usePipController";

    const videoPlayer =
        inject("pipVideoPlayer");
    const playerWrapper = ref(null);
    const feedback = ref({
        show: false,
        direction: "",
        text: ""
    });

    onMounted(() => {
        console.log("=== PIP PLAYER ===");
        console.log("videoPlayer:", videoPlayer);
        console.log("videoPlayer.value:", videoPlayer?.value);
        console.log("playerWrapper:", playerWrapper.value);
    });

    usePipController({
        videoPlayer,
        playerWrapper,
        feedback
    });
</script>

<style scoped>
    .pip-root {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .pip-video {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
    }

        .pip-video video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

    .pip-player {
        position: absolute;
        inset: 0;
        z-index: 10000;
        pointer-events: none;
    }

        .pip-player.show {
            opacity: 1;
            pointer-events: auto;
        }

    .pip-player-control-wrapper {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        /*
     * 전체 wrapper가 이벤트를 먹지 않도록
     */
        pointer-events: none;
        user-select: none;
        -webkit-user-select: none;
    }

</style>